import { render } from "./ConfirmRelocateModal.vue?vue&type=template&id=270ca7aa&scoped=true&ts=true&lang=pug"
import script from "./ConfirmRelocateModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmRelocateModal.vue?vue&type=script&lang=ts"

import "./ConfirmRelocateModal.vue?vue&type=style&index=0&id=270ca7aa&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270ca7aa"]])

export default __exports__